angular.module('tgaAdmin')
  .service('customFieldService', ['$http', 'envService', 'localStorageService', 'domainService',
    function ($http, envService, localStorageService, domainService) {
      const serverAddress = envService.read('serverAddress');

      function getCustomField(custom_field_id) {
        return $http({
          method: 'GET',
          url: `${serverAddress}customfield/${custom_field_id}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCustomFields(params) {
        params = params || {};
        params.domain = domainService.domain;

        return $http({
          method: 'GET',
          url: `${serverAddress}customfield`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addCustomField(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}customfield`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteCustomField(custom_field_id) {
        return $http({
          method: 'DELETE',
          url: `${serverAddress}customfield/${custom_field_id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateCustomField(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}customfield/${data.custom_field_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getCustomField,
        getCustomFields,
        addCustomField,
        deleteCustomField,
        updateCustomField,
      });
    }]);
